import { useCallback, useRef, useState } from 'react';
import { deleteCompanyCurrency } from 'services/Configuration/companyCurrenciesService';

export function useRemoveCompanyCurrency() {
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const removeCurrency = useCallback(async (id) => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setIsLoading(true);
    setError(null);
    try {
      const data = await deleteCompanyCurrency(id, controller.signal);
      setResult(data);
      return data;
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { result, isLoading, error, removeCurrency };
}
